import { CreateDeliveryAsset } from '../../../../../reduxToolkit/EquipmentAndMaterial/EquipmentApi';
import { DELIVERY_ASSET_TYPE } from './../Model/Model';
import {base64ToFile} from "../../../../../utils/Base64ToBlob";
/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */
export const uploadDeliveryAsset = async ({ deliveryId, photoPicker, dispatch }) => {
    const uploadFile = photoPicker?.fileSelected || base64ToFile(photoPicker?.selfieSrc, new Date().getTime());
    if(!uploadFile) return;
    // Create FormData to send multipart/form-data to the backend
    const formData = new FormData();

    // Attach the delivery identifie
    formData.append('id', deliveryId);
    // Define the type of asset being uploaded (DELIVERY or CLOSED)
    formData.append('uploadType', DELIVERY_ASSET_TYPE.CLOSED);

    // Attach the file as evidence for the delivery action
    formData.append('closedFile.files', uploadFile);

    // Send the original file name for audit and display purposes
    formData.append('closedFile.userFileNames', uploadFile.name);

    // Dispatch the Redux action to upload the delivery asset
    return dispatch(CreateDeliveryAsset(formData));
};
